import FoundryPhysicalProduct from "../lib/foundry_client/models/FoundryPhysicalProduct";
import { PhysicalProductType } from "../lib/contentful_client/models/ContentfulResponseModels";
import { PhysicalProductsState } from "../lib/models/PhysicalProducts";

export enum ShippingMethod {
  UspsGround = "usps_ground",
  UpsGround = "ups_ground",
  UspsPriority = "usps_priority",
}

interface ShippingMethodConfig {
  key: string;
  name: string;
  flatRateCents: number;
  deliveryStr: string;
  types: PhysicalProductType[];
  companyName: string;
  trackingLink: (number: string) => string;
}

export const SHIPPING_METHODS: { [key: string]: ShippingMethodConfig } = {
  ups_ground: {
    key: "ups_ground",
    name: "UPS Ground",
    flatRateCents: 600,
    deliveryStr: "1-5 business days after shipment",
    types: [PhysicalProductType.Fabric],
    companyName: "UPS",
    trackingLink: (number) =>
      `https://www.ups.com/track?loc=en_US&tracknum=${number}`,
  },
  usps_ground: {
    key: "usps_ground",
    name: "USPS Ground Advantage",
    flatRateCents: 600,
    deliveryStr: "2-5 business days after shipment",
    types: [
      PhysicalProductType.Print,
      PhysicalProductType.Zine,
      PhysicalProductType.Fabric,
    ],
    companyName: "USPS",
    trackingLink: (number) =>
      number.startsWith("1Z")
        ? `https://www.ups.com/track?loc=en_US&tracknum=${number}`
        : `https://tools.usps.com/go/TrackConfirmAction.action?tLabels=${number}`,
  },
  usps_priority: {
    key: "usps_priority",
    name: "USPS Priority Mail",
    flatRateCents: 1200,
    deliveryStr: "1-3 business days after shipment",
    types: [
      PhysicalProductType.Print,
      PhysicalProductType.Zine,
      PhysicalProductType.Fabric,
    ],
    companyName: "USPS",
    trackingLink: (number) =>
      number.startsWith("1Z")
        ? `https://www.ups.com/track?loc=en_US&tracknum=${number}`
        : `https://tools.usps.com/go/TrackConfirmAction.action?tLabels=${number}`,
  },
};

export const getValidShippingOptions = (
  physicalProductDetails: FoundryPhysicalProduct[],
  cartProducts: PhysicalProductsState
) => {
  const types = new Set(
    cartProducts
      .map((product) =>
        physicalProductDetails.find((d) => d.id === product.contentfulId)
      )
      .map((item) => item?.type)
      .filter((type) => type)
  );

  return Object.values(SHIPPING_METHODS).filter((method) =>
    method.types.find((t) => types.has(t))
  );
};

export const calculateShippingCost = (
  cartTotalWithoutTax: number,
  shippingMethod: string
) => {
  if (
    (shippingMethod === ShippingMethod.UspsGround ||
      shippingMethod === ShippingMethod.UpsGround) &&
    cartTotalWithoutTax >= 5000
  ) {
    return 0.0;
  }

  if (SHIPPING_METHODS[shippingMethod]) {
    return SHIPPING_METHODS[shippingMethod].flatRateCents;
  }

  throw new Error("Unknown shipping method");
};

// TODO(important): We should be taxing online stuff as well, so how does it work when we don't have physical products? need to figure out the "state" to tax from?
export const calculateTaxCost = (
  cartTotalIncludingShipping: number,
  state: string
) => {
  // We currently only have "nexus" in New York. We could potentially meet the thresholds for economic nexus in other states, usually:
  //
  // - over $100,000 in sales for the year
  // - over 200 orders for the year
  //
  // However, we will assume for simplicity that that is not the case. Due to the complexity of determining regional tax, Tax APIs are paid
  // and we are going to avoid them.
  //
  // Additionally, note that we only support sales in the United States.
  //
  // if (state === "NY") {
  //  return Math.ceil(0.08875 * cartTotalIncludingShipping);
  // }

  return 0.0;
};
